import { getInreesId } from "../store/reducers/authSlice";
import { useSelector } from "react-redux";

const TESTER_LIST = [87849, 86077, 180990, 114615];
export const useIsBetaTester = () => {
	const inreesId = useSelector(getInreesId);
	if (!inreesId) return false;
	return TESTER_LIST.includes(parseInt(inreesId)) || false;
};
